export enum RoomListForms {
  DeleteRoom = 'DeleteRoom',
}
